import React from 'react';
import { Video, PlayCircle, CalendarRange, Award, Headphones, Users } from 'lucide-react';

const items = [
  {
    num: '04',
    title: 'AULAS AO VIVO',
    desc: 'Acompanhamento direto com o mentor em tempo real, 1 aula por semana',
    icon: Video
  },
  {
    num: '20+',
    title: 'AULAS GRAVADAS',
    desc: 'Conteúdo completo e aprofundado para assistir quando quiser',
    icon: PlayCircle
  },
  {
    num: '01',
    title: 'ANO DE ACESSO',
    desc: 'Acesso total à plataforma exclusiva durante 12 meses',
    icon: CalendarRange
  },
  {
    num: '01',
    title: 'CERTIFICADO',
    desc: 'Certificado oficial de conclusão da WING Academy Brasil',
    icon: Award
  },
  {
    num: '∞',
    title: 'SUPORTE',
    desc: 'Suporte prioritário para tirar todas as suas dúvidas',
    icon: Headphones
  },
  {
    num: '01',
    title: 'COMUNIDADE',
    desc: 'Grupo exclusivo de alunos para networking e troca de experiências',
    icon: Users
  }
];

const Deliverables = () => {
  return (
    <section
      id="entregaveis"
      data-testid="deliverables-section"
      className="section-padding relative overflow-hidden bg-gradient-to-b from-black via-gray-900 to-black"
    >
      <div className="absolute inset-0 bg-grid-pattern opacity-30 pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-10 md:mb-16">
            <div className="inline-block bg-yellow-500/10 border border-yellow-500/30 px-4 py-1.5 md:px-5 md:py-2 rounded-full mb-3 md:mb-4">
              <span className="text-yellow-400 font-semibold text-[11px] md:text-sm tracking-widest uppercase">
                O Que Você Vai Receber
              </span>
            </div>
            <h2
              data-testid="deliverables-title"
              className="text-[1.75rem] leading-tight sm:text-4xl lg:text-5xl font-bold text-white"
            >
              TUDO QUE VOCÊ PRECISA PARA <br className="hidden md:block" />
              <span className="highlight-marker-solid">DOMINAR A WING</span>
            </h2>
            <p className="mt-3 md:mt-4 text-sm sm:text-base md:text-lg text-gray-400 max-w-2xl mx-auto px-2">
              De forma completa, prática e profissional.
            </p>
          </div>

          {/* Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {items.map((it, idx) => {
              const Icon = it.icon;
              return (
                <div
                  key={idx}
                  data-testid={`deliverable-card-${idx}`}
                  className="relative glass-dark border border-white/5 hover:border-yellow-500/40 rounded-2xl p-5 sm:p-6 md:p-7 transition-all duration-300 md:hover:-translate-y-1 group"
                >
                  {/* Big number badge (top-right) */}
                  <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-yellow-500 text-black font-black text-xs md:text-base px-2.5 py-1 md:px-3 rounded-full shadow-[0_0_20px_rgba(251,191,36,0.35)]">
                    {it.num}
                  </div>

                  {/* Icon */}
                  <div className="w-11 h-11 md:w-14 md:h-14 rounded-xl bg-yellow-500/10 border border-yellow-500/20 flex items-center justify-center mb-4 md:mb-5 group-hover:bg-yellow-500/20 transition-colors">
                    <Icon className="w-5 h-5 md:w-7 md:h-7 text-yellow-400" />
                  </div>

                  <h3 className="text-base sm:text-lg md:text-xl font-black text-white tracking-tight mb-1.5 md:mb-2">
                    {it.title}
                  </h3>
                  <p className="text-gray-400 text-xs sm:text-sm md:text-[15px] leading-relaxed">
                    {it.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Deliverables;
